export interface User {
  id?: string;
  email: string;
  token: string;
  tokenType?: string;
  name: string;
  bio?: string | null;
  image?: string | null;
  activeRole?: Role | null;
  emailVerifiedAt?: Date | null;
}

export enum Role {
  LANDLORD = 'LANDLORD',
  TENANT = 'TENANT',
}

export interface UserRegistration {
  name: string;
  email: string;
  password: string;
  passwordConfirmation: string;
}

export interface UserResponseDto {
  id: string;
  name: string;
  email: string;
  emailVerifiedAt?: Date | null;
}

export interface LoginDto {
  email: string;
  password: string;
}

export interface AuthTokenResponseDto {
  id: string;
  name: string;
  email: string;
  token: string;
  tokenType: string;
  refreshToken: string;
  activeRole: Role;
  emailVerifiedAt?: Date | null;
}

export interface RefreshTokenDto {
  refreshToken: string;
}


